
export default "/assets/user-plus-micro.d990eab8.svg"